export default "__VITE_ASSET__DAAM5ZV1__"